import ContractSubtypeCreate from './ContractSubtypeCreate'
import ContractSubtypeDelete from './ContractSubtypeDelete'
import ContractSubtypeUpdate from './ContractSubtypeUpdate'
import {
  fetchContractSubtypes,
  toggleContractSubtype,
} from 'actions/contracts/contractSubtypeActions'
import EmptyList from 'components/common/EmptyList'
import Modal from 'components/common/Modal'
import Table from 'components/common/tables/Table'
import SectionHeaderMenu from 'components/nav/SectionHeaderMenu'
import { useAuth } from 'hooks/useAuth'
import useModal from 'hooks/useModal'
import _ from 'lodash'
import { MDBCardBody } from 'mdbreact'
import React, { useEffect, useState, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'

const NEW_HEADER = 'New Contract Subtype'
const EDIT_HEADER = 'Edit Contract Subtype'
const DELETE_HEADER = 'Delete Contract Subtype'

const ContractSubtypeList = () => {
  //// HOOKS.
  const auth = useAuth()
  const dispatch = useDispatch()
  const {
    modalOpen,
    headerText,
    setHeaderText,
    formId,
    footer,
    setFooter,
    actions,
    setActions,
    selected,
    setSelected,
    params,
    setParams,
    setModalState,
  } = useModal()

  //// GLOBAL STATE.
  const { subtypesAvailable, lastAction } = useSelector(
    (state) => state.contractSubtypes
  )

  //// LOCAL STATE.
  const [tableData, setTableData] = useState({
    columns: [
      {
        label: '#',
        field: 'id',
        sort: 'desc',
      },
      {
        label: 'Name',
        field: 'name',
        sort: 'desc',
        minimal: 'lg',
      },
      {
        label: 'Type',
        field: 'contract_type.name',
        sort: 'desc',
        minimal: 'lg',
      },
      {
        label: 'Date Created (UTC)',
        field: 'created_at',
        date: true,
        sort: 'desc',
      },
      {
        label: 'Available',
        field: 'is_available',
        toggleControl: true,
        sort: 'disabled',
      },
      {
        label: '',
        field: 'buttons',
        sort: 'disabled',
        minimal: 'lg',
      },
    ],
  })

  //// LIFECYCLE HELPERS.

  //// MEMOS.

  //// EFFECTS.
  useEffect(() => {
    dispatch(fetchContractSubtypes('list'))
  }, [dispatch])

  //// RENDER VARS & HELPERS.
  const toggleModal = useCallback(
    (e, type, item) => {
      if (e) e.preventDefault()

      switch (type) {
        case 'new':
          setHeaderText(NEW_HEADER)
          setFooter(true)
          setActions([
            {
              text: 'Submit',
              color: 'primary',
              additionalProps: {
                form: formId,
                type: 'submit',
              },
            },
          ])
          setModalState(true)
          break
        case 'edit':
          setHeaderText(EDIT_HEADER)
          setFooter(true)
          setActions([
            {
              text: 'Update',
              color: 'primary',
              additionalProps: {
                form: formId,
                type: 'submit',
              },
            },
          ])
          setSelected(item)
          setModalState(true)
          break
        case 'delete':
          setHeaderText(DELETE_HEADER)
          setFooter(true)
          setActions([
            {
              text: 'Delete',
              color: 'danger',
              additionalProps: {
                form: formId,
                type: 'submit',
              },
            },
          ])
          setSelected(item)
          setModalState(true)
          break
        default:
          setModalState(false)
          break
      }
    },
    [formId, setActions, setFooter, setHeaderText, setModalState, setSelected]
  )

  //// RENDER.
  return (
    <>
      <SectionHeaderMenu
        menuData={{
          order: 2,
          show: true,
          linkItems: [
            {
              name: 'Create',
              url: `/admin/contracts/subtypes`,
              exact: true,
              additionalProps: {
                active: true,
                onClick: (e) => toggleModal(e, 'new'),
                className: 'btn-sm',
              },
            },
          ],
        }}
      />
      <MDBCardBody>
        {_.size(subtypesAvailable) ? (
          <Table
            section="Subtype"
            tableData={tableData}
            setTableData={setTableData}
            rowData={subtypesAvailable}
            sort={['id', 'desc']}
            toggleAvailability={(item, toggle) => {
              dispatch(toggleContractSubtype(item, toggle))
            }}
            toggleModal={toggleModal}
            updatedState={lastAction}
            downloadableCSV
            editButton
            deleteButton
          />
        ) : _.isEmpty(subtypesAvailable) ? (
          <EmptyList
            name="contract subtype"
            namePlural="contract subtypes"
            userRole={auth?.user?.user_level}
            createElement={
              <span className="link" onClick={(e) => toggleModal(e, 'new')}>
                Create
              </span>
            }
          />
        ) : (
          ''
        )}
      </MDBCardBody>
      <Modal
        isOpen={modalOpen}
        toggle={toggleModal}
        headerText={headerText}
        includeFooter={footer}
        actionButtons={actions}
      >
        {headerText === NEW_HEADER ? (
          <ContractSubtypeCreate
            formId={formId}
            params={params}
            setParams={setParams}
            closeModal={() => setModalState(false)}
          />
        ) : headerText === EDIT_HEADER ? (
          <ContractSubtypeUpdate
            formId={formId}
            params={params}
            setParams={setParams}
            selected={selected}
            setSelected={setSelected}
            closeModal={() => setModalState(false)}
          />
        ) : headerText === DELETE_HEADER ? (
          <ContractSubtypeDelete
            formId={formId}
            selected={selected}
            closeModal={() => setModalState(false)}
          />
        ) : (
          ''
        )}
      </Modal>
    </>
  )
}

export default ContractSubtypeList
